// Network
let protocol;
let wsProtocol;
if (window.__RUNTIME_CONFIG__.TLS === 'yes' || window.__RUNTIME_CONFIG__.PROXY_TLS === 'yes') {
  protocol = 'https';
  wsProtocol = 'wss';
} else {
  protocol = 'http';
  wsProtocol = 'ws';
}

// Network
export let API_ENDPOINT;
export let AI_ENDPOINT;
export let DATA_ENDPOINT;
export let AI_WEBSOCKET;
export let DATA_WEBSOCKET;

if (window.__RUNTIME_CONFIG__.NODE_ENV === 'development') {
  console.log('Environment: development')
  API_ENDPOINT = `${protocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}:3000`;
  AI_ENDPOINT = `${protocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}:5000`;
  DATA_ENDPOINT = `${protocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}:4000`;
  AI_WEBSOCKET = `${protocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}:5000`;
  DATA_WEBSOCKET = `${wsProtocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}:4000/ws`;
} else {
  console.log('Environment: production')
  API_ENDPOINT = `${protocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}/API`;
  AI_ENDPOINT = `${protocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}/AI`;
  DATA_ENDPOINT = `${protocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}/data`;
  AI_WEBSOCKET = `${protocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}`;
  DATA_WEBSOCKET = `${wsProtocol}://${window.__RUNTIME_CONFIG__.SERVER_IP}/ws/`;
}

// Frontend
export const ACME = window.__RUNTIME_CONFIG__.ACME;
export const DEMO = window.__RUNTIME_CONFIG__.DEMO === 'yes';
